<script setup lang="ts">
    import { InfoIcon } from '@lucide/vue';
    import { useSlots } from 'vue';
    import EchoPopover from './EchoPopover.vue';

    const model = defineModel<boolean>();

    withDefaults(
        defineProps<{
            id: string;
            helpHint?: string;
            disabled?: boolean;
        }>(),
        {
            disabled: false,
        }
    );

    const slots = useSlots();

    const checkboxClasses = 'Custom-checkbox';
</script>

<template>
    <label
        v-if="!slots.help"
        :for="id"
        class="inline-flex items-start py-0.5 group cursor-pointer text-body"
    >
        <input
            :id="id"
            v-model="model"
            type="checkbox"
            :disabled="disabled"
            :class="checkboxClasses"
        />
        <span v-if="slots.default">
            <slot />
        </span>
    </label>

    <EchoPopover v-else type="text">
        <template #button="{ anchor, togglePopover, buttonAttrs }">
            <div class="inline-flex items-start group text-body">
                <input
                    :id="id"
                    v-model="model"
                    type="checkbox"
                    :disabled="disabled"
                    :class="checkboxClasses"
                />
                <div class="flex flex-wrap items-center">
                    <label :for="id" class="cursor-pointer">
                        <span v-if="slots.default">
                            <slot />
                        </span>
                    </label>
                    <button
                        v-if="slots.help"
                        :ref="anchor"
                        type="button"
                        class="block p-1 custom-focus rounded-full -mb-1.5 -mt-2 ml-1"
                        :aria-label="helpHint"
                        v-bind="buttonAttrs"
                        @click="togglePopover"
                    >
                        <InfoIcon class="size-5 cursor-pointer" />
                    </button>
                </div>
            </div>
        </template>
        <template #popover>
            <slot name="help" />
        </template>
    </EchoPopover>
</template>
